import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ShareContainer, ShareButton, ShareMenu, ShareItem, CopyLinkButton } from './style';

const SocialShare = ({ url, title, description }) => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = url || window.location.href;
  const shareTitle = title || t('share_title_default');
  const shareDescription = description || t('share_description_default');

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback para navegadores que no soportan clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = shareUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareDescription + '\n\n' + shareUrl)}`
  };

  const handleShare = (platform) => {
    window.open(shareLinks[platform], '_blank', 'width=600,height=400');
    setShowMenu(false);
  };

  // Web Share API (para móviles)
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareDescription,
          url: shareUrl,
        });
        setShowMenu(false);
      } catch (err) {
        // Share error handled silently
      }
    } else {
      setShowMenu(!showMenu);
    }
  };

  return (
    <ShareContainer>
      <ShareButton onClick={handleNativeShare}>
        <i className="fas fa-share-alt" style={{marginRight: '6px'}}></i> {t('share')}
      </ShareButton>
      
      {showMenu && !navigator.share && (
        <ShareMenu>
          <ShareItem onClick={() => handleShare('whatsapp')} style={{color: '#25D366'}}>
            <i className="fab fa-whatsapp" style={{fontSize: '20px', marginRight: '10px'}}></i>
            WhatsApp
          </ShareItem>
          <ShareItem onClick={() => handleShare('facebook')} style={{color: '#1877F2'}}>
            <i className="fab fa-facebook" style={{fontSize: '20px', marginRight: '10px'}}></i>
            Facebook
          </ShareItem>
          <ShareItem onClick={() => handleShare('twitter')} style={{color: '#1DA1F2'}}>
            <i className="fab fa-twitter" style={{fontSize: '20px', marginRight: '10px'}}></i>
            Twitter
          </ShareItem>
          <ShareItem onClick={() => handleShare('telegram')} style={{color: '#0088cc'}}>
            <i className="fab fa-telegram" style={{fontSize: '20px', marginRight: '10px'}}></i>
            Telegram
          </ShareItem>
          <ShareItem onClick={() => handleShare('linkedin')} style={{color: '#0A66C2'}}>
            <i className="fab fa-linkedin" style={{fontSize: '20px', marginRight: '10px'}}></i>
            LinkedIn
          </ShareItem>
          <ShareItem onClick={() => handleShare('email')} style={{color: '#EA4335'}}>
            <i className="fas fa-envelope" style={{fontSize: '20px', marginRight: '10px'}}></i>
            Email
          </ShareItem>
          <CopyLinkButton onClick={handleCopyLink}>
            <i className={copied ? "fas fa-check" : "fas fa-link"} style={{fontSize: '18px', marginRight: '10px'}}></i>
            {copied ? t('share_link_copied') : t('share_copy_link')}
          </CopyLinkButton>
        </ShareMenu>
      )}
      
      {showMenu && (
        <div 
          onClick={() => setShowMenu(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'transparent',
            zIndex: 999
          }}
        />
      )}
    </ShareContainer>
  );
};

export default SocialShare;
